// extracted by mini-css-extract-plugin
export default {"add_button":"InventoryListForSale_add_button__NEL63","table":"InventoryListForSale_table__rbtI7","contet_table":"InventoryListForSale_contet_table__I09PW"};